export default __webpack_public_path__ + "static/media/end-game.ebebbdb2.yaml";